{
  "name": "ai-assist-ui",
  "$schema": "../../node_modules/nx/schemas/project-schema.json",
  "projectType": "application",
  "sourceRoot": "apps/ai-assist-ui/src",
  "prefix": "app",
  "generators": {
    "@schematics/angular:application": {
      "strict": true
    }
  },
  "targets": {
    "build": {
      "executor": "@angular-devkit/build-angular:application",
      "options": {
        "outputPath": "dist/apps/ai-assist-ui",
        "index": "apps/ai-assist-ui/src/index.html",
        "browser": "apps/ai-assist-ui/src/main.ts",
        "polyfills": ["apps/ai-assist-ui/src/polyfills.ts"],
        "tsConfig": "apps/ai-assist-ui/tsconfig.app.json",
        "assets": [
          "apps/ai-assist-ui/src/favicon.ico",
          "apps/ai-assist-ui/src/assets",
          "apps/ai-assist-ui/src/redirectPage.html"
        ],
        "styles": ["apps/ai-assist-ui/src/Bullhorn-Glyphicons.css", "apps/ai-assist-ui/src/reset.css", "apps/ai-assist-ui/src/styles.scss"],
        "stylePreprocessorOptions": {
          "includePaths": [
            "apps/ai-assist-ui/src/assets/css-imports",
            "libs/shared/styles/src/lib/core",
            "libs/shared/styles/src/lib/misc",
            "libs/shared/styles/src/lib/material/components",
            "libs/shared/ui"
            ]
        },
        "scripts": []
      },
      "configurations": {
        "local": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true
        },
        "dev": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.dev.ts"
            }
          ],
          "outputHashing": "all"
        },
        "uat": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.uat.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-internal": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-internal.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-external": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-external.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-tester1": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-tester1.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-tester2": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-tester2.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-tester3": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-tester3.ts"
            }
          ],
          "outputHashing": "all"
        },
        "qa-tester4": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true,
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.qa-tester4.ts"
            }
          ],
          "outputHashing": "all"
        },
        "prod": {
          "budgets": [
            {
              "type": "initial",
              "maximumWarning": "10mb",
              "maximumError": "10mb"
            },
            {
              "type": "anyComponentStyle",
              "maximumWarning": "15kb",
              "maximumError": "20kb"
            }
          ],
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.prod.ts"
            }
          ],
          "outputHashing": "all"
        },
        "us": {
          "budgets": [
            {
              "type": "initial",
              "maximumWarning": "10mb",
              "maximumError": "10mb"
            },
            {
              "type": "anyComponentStyle",
              "maximumWarning": "15kb",
              "maximumError": "20kb"
            }
          ],
          "fileReplacements": [
            {
              "replace": "apps/ai-assist-ui/src/environments/environment.ts",
              "with": "apps/ai-assist-ui/src/environments/environment.us.ts"
            }
          ],
          "outputHashing": "all"
        }
      },
      "defaultConfiguration": "local",
      "outputs": ["{options.outputPath}"]
    },
    "serve": {
      "executor": "@angular-devkit/build-angular:dev-server",
      "configurations": {
        "local": {
          "buildTarget": "ai-assist-ui:build:local",
          "port": 4203
        },
        "uat": {
          "buildTarget": "ai-assist-ui:build:uat"
        },
        "qa-internal": {
          "buildTarget": "ai-assist-ui:build:qa-internal"
        },
        "qa-external": {
          "buildTarget": "ai-assist-ui:build:qa-external"
        },
        "qa-tester1": {
          "buildTarget": "ai-assist-ui:build:qa-tester1"
        },
        "qa-tester2": {
          "buildTarget": "ai-assist-ui:build:qa-tester2"
        },
        "qa-tester3": {
          "buildTarget": "ai-assist-ui:build:qa-tester3"
        },
        "qa-tester4": {
          "buildTarget": "ai-assist-ui:build:qa-tester4"
        },
        "prod": {
          "buildTarget": "ai-assist-ui:build:prod"
        },
        "us": {
          "buildTarget": "ai-assist-ui:build:us"
        }
      },
      "defaultConfiguration": "local",
      "continuous": true
    },
    "extract-i18n": {
      "executor": "@angular-devkit/build-angular:extract-i18n",
      "options": {
        "buildTarget": "ai-assist-ui:build"
      }
    },
    "test": {
      "executor": "@nx/jest:jest",
      "outputs": ["{workspaceRoot}/coverage/{projectRoot}"],
      "options": {
        "jestConfig": "apps/ai-assist-ui/jest.config.ts",
        "passWithNoTests": true,
        "tsConfig": "apps/ai-assist-ui/tsconfig.spec.json"
      }
    }
  }
}
